export default __webpack_public_path__ + "static/media/matriz.69e4452e.png";